import { useEffect } from 'react';
import { useStore } from '@app/store/useStore.hook';

export const useRefreshAccountOnPageFocus = () => {
  const getMe = useStore.useGetMe();

  useEffect(() => {
    const handleVisibilityChange = async () => {
      if (document.visibilityState === 'visible') {
        await getMe();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [getMe]);
};
